export default class DashboardCountModel {
  constructor(obj) {
    obj = obj || {};
    this.count = obj.count;
  }
}
